<template>
  <profile-layout v-if="user">
    <v-layout row wrap>
      <v-flex xs12>
        <v-container fill-height w--max--800>
          <v-layout row wrap>
            <!--header-->
            <v-flex xs12 class="text-xs-center membership-header">
              <!-- <app-name-page :name="isFromSignup ? 'My Profile' : 'My Profile'"
                                           color="var(--green)"></app-name-page> -->



              <div class="header-container">
                <router-link to="/dashboard" class="back-link">
                  ← Back to Dashboard
                </router-link>
                <h2 class="title1">My Profile</h2>
              </div>
            </v-flex>
            <!--list of the work type-->
            <v-flex xs12>
              <div>
                <v-select label="My work preferences*" placeholder="Please choose" v-model="user.type_work_list[0]"
                  :items="workTypes" item-value="id" item-text="name" v-validate="'required'"
                  data-vv-name="type_work_list"
                  :class="{ 'app-text-light  labelclass selectcustomlabel': true, 'error--text is-invalid': errors.first('type_work_list') }"
                  :menu-props="{ offsetY: true }" outline>
                  <template slot="selection" slot-scope="{item, index}">
                    <span class="text--black">{{ item.name | capitalize }}</span>
                  </template>
                </v-select>
              </div>
            </v-flex>

            <v-flex xs12>
              <span
                :class="{ 'app-text-light d-inline-block mb-2 labelclass': true, 'error--text is-invalid': errors.first('caregiver_category_list') }">
                Domestic care categories*</span>
              <AppBtnTogglecareg @caregivemain_cat="getcaregiver_listing($event)" v-validate="'required'"
                v-model="user.caregiver_category_list" data-vv-name="caregiver_category_list" icon-dir="brand"
                propvalue="caregiverscategory" :items="caregivers"></AppBtnTogglecareg>

            </v-flex>

            <v-flex xs12 mt-3 v-if="childopt">
              <div>
                <span :class="{ 'app-text-light d-inline-block mb-2 labelclass': true }">
                  Housekeeping preferences</span>
              </div>
              <app-btn-toggle-qualifications @sub_cat_eventhandler="getcaregiver_sublisting($event)"
                v-model="user.caregiver_category_listing_options" data-vv-name="caregiver_category_listing_options"
                icon-dir="brand" propvalue="caregivesubcategory" :items="childopt"></app-btn-toggle-qualifications>
            </v-flex>

            <!--
                        <v-flex xs12 mt-5>
                            <div class="d-flex">
                                <span :class="{'app-text-light d-inline-block mb-2': true, 'error--text is-invalid': errors.has('child_count')}">
                                    How many children do you feel comfortable caring for at a time*</span>
                                <span class="app-text-medium text-xs-right _count-span">{{ user.child_count || '1-5+'}}{{user.child_count === 5 ? '+':''}}</span>
                            </div>
                            <v-slider v-model="user.child_count"
                                      v-validate="'required|min_value:1'"
                                      data-vv-name="child_count"
                                      :max="5"
                                      class="my-0"></v-slider>
                        </v-flex>
                        -->
            <!--personal qualifications-->
            <v-flex xs12 mt-3>
              <div>
                <span
                  :class="{ 'app-text-light d-inline-block mb-2': true, 'error--text is-invalid': errors.first('personal_questions_list') }">
                  About me*</span>
              </div>
              <app-btn-toggle-qualifications v-model="user.personal_questions_list" icon-dir="brand"
                v-validate="'required'" data-vv-name="personal_questions_list"
                :items="qualifications"></app-btn-toggle-qualifications>
            </v-flex>

            <!-- <v-flex xs12 mt-5>
                            <div class="d-flex">
                                <span :class="{'app-text-light d-inline-block mb-2': true, 'error--text is-invalid': errors.first('work_distance')}">
                                    How far are you willing to travel for work?*</span>
                                <span class="app-text-medium text-xs-right _count-span">{{ user.work_distance || '10-70'}} km</span>
                            </div>
                            <v-slider v-model="user.work_distance"
                                      v-validate="'required|min_value:1'"
                                      data-vv-name="work_distance"
                                      :step="10"
                                      :max="70"
                                      class="my-0"></v-slider>
                        </v-flex> -->
            <!--residency status-->
            <v-flex xs12 mt-3>
              <div>
                <v-select label="Australian residency status*" placeholder="Please choose"
                  v-model="user.residence_status_list[0]" :items="residenceStatuses" v-validate="'required'"
                  data-vv-name="residence_status_list" item-value="id" item-text="name" :menu-props="{ offsetY: true }"
                  :class="{ 'app-text-light labelclass selectcustomlabel': true, 'error--text is-invalid': errors.first('residence_status_list') }"
                  outline>
                  <template slot="selection" slot-scope="{item, index}">
                    <span class="text--black">{{ item.name | capitalize }}</span>
                  </template>
                </v-select>
              </div>
            </v-flex>

            <!--Availability -->
            <v-flex xs12>
              <h2 class="my-5 text-xs-center" id="availability_list_section">Availability</h2>
            </v-flex>
            <v-flex xs12>
              <div>
                <span
                  :class="{ 'app-text-light d-inline-block mb-2': true, 'error--text is-invalid': availability_list_invalid }">
                  My weekly availability*</span>
                <app-table-availability-rates v-model="user.availability_list" v-validate="'required'"
                  data-vv-name="availability_list"></app-table-availability-rates>
              </div>
            </v-flex>

            <!--Pay per Hour -->
            <v-flex xs12>
              <h2 class="my-5 text-xs-center">Pay per Hour</h2>
            </v-flex>
            <v-flex xs12>
              <div class="pay-per-hour" v-if="user.availability_list[0]">
                <v-text-field v-model="user.availability_list[0].pay" label="Pay per Hour" type="text"
                  class="app-text-field" outline prefix="$" mask="###"></v-text-field>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs12>
        <v-container grid-list-xl w--max--800>
          <v-layout row wrap>
            <!--profile descriptions-->
            <v-flex tag="h2" class="my-5 text-xs-center">About me</v-flex>
            <v-flex xs12>
              <v-textarea label="A few sentences to help us get to know you better (200-400 characters recommended)"
                v-model="user.description" v-validate="'required'" data-vv-name="description" maxlength="500"
                height="128"
                :class="{ 'app-text-light labelclass': true, 'error--text is-invalid': errors.first('description') }"
                outline no-resize></v-textarea>
            </v-flex>
            <!--                        
                        <v-flex xs12 md6>
                            <v-text-field label="Music instruments"
                                          v-model="user.music_instruments"
                                          outline></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field label="Sports"
                                          v-model="user.sports"
                                          outline></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field label="School subjects"
                                          v-model="user.school_subject"
                                          outline></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                            <v-text-field label="Languages"
                                          v-model="user.languages"
                                          outline></v-text-field>
                        </v-flex>
-->
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs12>
        <v-container w--max--800>
          <v-layout row wrap>
            <!--experience working-->
            <!-- <v-flex xs12>
                            <div class="d-flex">
                                <span :class="{'app-text-light d-inline-block mb-2': true, 'error--text is-invalid': errors.first('years_exp')}">
                                    Years of experience working with children*</span>
                                <span class="app-text-medium text-xs-right _count-span">
                                {{ user.years_exp || '0-30+'}}{{user.years_exp > 29 ? '+':''}} years</span>
                            </div>
                            <v-slider v-model="user.years_exp"
                                      v-validate="'required|min_value:1'"
                                      data-vv-name="years_exp"
                                      :max="30"
                                      class="my-0"></v-slider>
                        </v-flex> -->
            <!--profile pictures-->
            <v-flex xs12 my-3>
              <div class="mb-2">
                <span class="app-text-light">Profile pictures</span>
              </div>
              <app-card-profile-images v-model="images"></app-card-profile-images>
            </v-flex>
            <!--profile background-->
            <v-flex xs12 my-4>
              <div class="mb-2">
                <span class="app-text-light" style="display: none;">Profile background (optional)</span>
              </div>
              <app-card-profile-bg v-model="user.theme_body"></app-card-profile-bg>
            </v-flex>
            <!--Visible profile-->
            <v-flex xs12 my-3 style="display: none;">
              <div>
                <span class="app-text-light">Forum profile visibility*</span>
              </div>
              <v-radio-group v-model="user.is_forumprofilevisible">
                <v-radio
                  label="Visible - your forum profile is live on our website. Only other NGs can view your profile and contact you or connect with you."
                  :value="1" :ripple="false"></v-radio>
                <v-radio label="Hidden - your forum profile is hidden on our website and will not be found by NGs."
                  :value="0" :ripple="false"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 my-3 style="display: none;">
              <div>
                <span class="app-text-light">Live status*</span>
              </div>
              <v-radio-group v-model="user.is_livestatusvisible">
                <v-radio label="Visible - show me when I’m online on our website." :value="1" :ripple="false"></v-radio>
              </v-radio-group>
            </v-flex>
            <!--actions-->
            <v-flex xs12 my-3 class="text-xs-center">
              <v-btn v-if="isFromSignup" to="/signup/step-3/nanny" color="primary" class="v-btn--default elevation-0">
                Back
              </v-btn>
              <v-btn v-if="isFromSignup" @click="proceedWithoutValidation" :loading="loadingskip" color="primary"
                class="v-btn--default elevation-0">
                Skip
              </v-btn>
              <v-btn @click="validateAndScrollToFirstError" :loading="loading" color="primary"
                class="v-btn--default elevation-0">
                {{ isFromSignup ? 'Continue' : 'Save' }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </profile-layout>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { profile as actions } from '@/store/types/action-types'
import ParseError from '@/mixins/parse-error'
import AppBtnToggleQualifications from '../../../components/app-buttons/app-btn-toggle-qualifications'
import AppCardProfileImages from '../../../components/app-card/app-card-profile-images'
import AppBtnTogglecareg from '../../../components/app-buttons/app-btn-toggle-caregiver'
import AppCardProfileBg from '../../../components/app-card/app-card-profile-bg'
import AppTableAvailabilityRates from '../../../components/app-table/app-table-availability-rates'
import AppNamePage from '../../../components/app-name-page'
import AppProfileWwc from './wwc/index'
import ProfileLayout from './profile-layout'

export default {
  name: 'app-profile',

  components: {
    ProfileLayout,
    AppProfileWwc,
    AppNamePage,
    AppTableAvailabilityRates,
    AppCardProfileBg,
    AppCardProfileImages,
    AppBtnToggleQualifications,
    AppBtnTogglecareg
  },

  mixins: [ParseError],

  props: ['isFromSignup'],

  data() {
    return {
      user: null, // <- NannyClass
      availability_list_invalid: false,
      childopt: null,
    }
  },

  computed: {
    ...mapGetters('catalogs', [
      'workTypes',
      'caregivers',
      'childAge',
      'qualifications',
      'preferences',
      'residenceStatuses'
    ]),
    ...mapGetters('catregiver_subcategory', [
      'subcategory',
    ]),
    loading() {
      return this.$store.getters['profile/loading']
    },
    images() {
      return this.$auth.user().images || []
    }
  },

  mounted() {
    this.user = Object.assign({}, this.$auth.user())
    // subcategory caregiver
    localStorage.removeItem("subcategory_caregiver");
    var getdefault_subcat = this.user.caregiver_category_listing_options; // store to local storage
    localStorage.setItem("subcategory_caregiver", JSON.stringify(getdefault_subcat));
    // subcategory caregiver end here

    // if (! this.user.is_jobprofilevisible) {
    //   this.showSnackBar("Your profile is currently hidden. To make your profile visible on the website, please complete 'My Profile' section here.", "error")
    // }
  },

  methods: {
    getcaregiver_listing: function (getevent_arr) {
      var categoryid = getevent_arr[0];
      var if_selected = getevent_arr[1];
      var if_chdild = getevent_arr[2];
      if (if_selected == true) {
        this.$store.dispatch('catregiver_subcategory/FETCH_CAREGIVER_SUBCATEGORY', categoryid)
          .then((res) => {
            let get_childs = this.$store.getters['catregiver_subcategory/subcategory'];
            if (get_childs) {
              if (get_childs.length > 1) {
                this.childopt = get_childs;
                this.user.caregiver_category_listing_options = JSON.parse(localStorage.getItem("subcategory_caregiver"));
              } else {
                this.childopt = null;
              }
            } else {
              this.childopt = null;
            }

          })
      } else {
        if (if_chdild == 1) {
          this.user.caregiver_category_listing_options = [];
        }
        this.childopt = null;
      }
    },
    getcaregiver_sublisting: function (event_arr) {
      console.log(event_arr);
      var categoryid = event_arr[0];
      var if_selected = event_arr[1];
      if (if_selected == true) {
        let selectedelements = JSON.parse(localStorage.getItem("subcategory_caregiver"))
        console.log(selectedelements.indexOf(parseInt(categoryid)))
        if (selectedelements.indexOf(parseInt(categoryid)) == -1)
          selectedelements.push(parseInt(categoryid));
        localStorage.setItem("subcategory_caregiver", JSON.stringify(selectedelements));
      } else {
        var getselecteditems = JSON.parse(localStorage.getItem("subcategory_caregiver"));
        const index = getselecteditems.indexOf(parseInt(categoryid));
        if (index > -1) { // only splice array when item is found
          getselecteditems.splice(index, 1); // 2nd parameter means remove one item only
        }
        localStorage.setItem("subcategory_caregiver", JSON.stringify(getselecteditems));
        console.log(localStorage.getItem("subcategory_caregiver"))
      }
      console.log(JSON.parse(localStorage.getItem("subcategory_caregiver")));
    },
    proceedWithoutValidation() {
      this.$auth.fetch({
        enabled: true,
        success: () => {
          document.cookie = 'rememberMe=false'
          this.$router.push('/dashboard')
          this.showSnackBar(
            'Please complete your <a href="/profile" style="color: white; text-decoration: underline;">profile</a> in order to access job listings and connect with customers.',
            'warning'
          );
        },
        error: () => (this.$router.push('signup'))
      })
    },
    validateAndScrollToFirstError() {
      this.$validator.validateAll().then(valid => {
        if (!valid) {
          const firstErrorElement = document.querySelector('.is-invalid');
          if (firstErrorElement) {
            firstErrorElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        } else {
          this.updateProfile();
        }
      });
    },
    updateProfile() {
      this.checkAvailabilityListValid()
      /* this.checkAvailabilityListValid()

       if (this.availability_list_invalid) {
           this.errors.add({
             field: 'availability_list',
             msg: 'This field is required'
           })

           document.getElementById('availability_list_section').scrollIntoView()
       } else {*/
      this.$validator.validateAll().then(result => {

        if (this.availability_list_invalid) {
          this.errors.add({
            field: 'availability_list',
            msg: 'This field is required'
          })
          this.goToError()
          return false
        }
        if (result) {
          this.user.working_with_cc = 1;
          this.$store.dispatch('profile/' + actions.UPDATE_PROFILE, this.user)
            .then((user) => {
              if (this.isFromSignup) {
                this.$auth.fetch({
                  enabled: true,
                  success: () => {
                    document.cookie = 'rememberMe=false'
                    this.showSnackBar('Your profile has been set up successfully.', 'success')
                    this.$router.push('/dashboard')
                  },
                  error: () => (this.$router.push('signup'))
                })
              } else {
                this.$auth.user(user)
                localStorage.setItem('auth._user', JSON.stringify(user))
                localStorage.setItem("subcategory_caregiver", JSON.stringify(this.user.caregiver_category_listing_options));
                this.showSnackBar('Your profile has been set up successfully.', 'success')
              }
            })
            .catch((error) => {
              if (error.response.status === 422) {
                this.showErrors(error.response.data.errors)
                this.goToError()
              }
            })
        } else {
          this.goToError()
        }
      })
      /* } */
    },
    goToError() {
      try {
        this.$vuetify.goTo(`[data-vv-name="${this.errors.items[0].field}"]`)
      } catch (e) {
        console.warn(e)
      }
    },
    checkAvailabilityListValid() {
      const firstErrorElement = document.querySelector('.is-invalid');
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
      this.availability_list_invalid = true

      this.user.availability_list.forEach((item, index) => {
        if (item.mon || item.tue || item.wed || item.thu || item.fri || item.sat || item.sun) {
          this.availability_list_invalid = false
        }
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    Vue.auth.fetch({
      enabled: true,
      success: () => {
        next()
      },
      error: () => (Vue.router.push('signup'))
    })
  }
}
</script>

<style lang="stylus">
    ._count-span
        min-width 80px
        padding-top 2px

    .pay-per-hour .v-text-field__prefix
        margin-top 0px !important
    .selectcustomlabel label
      font-size 1.143em !important

    .membership-header{display:flex;justify-content:center}
    .header-container{width:100%;display:flex;align-items:center;justify-content:space-between;position:relative}
    ._with-desc
      margin 25px 0px 0 0 
      font-size 14px
      padding 0 10px
    
    .title1{
      position:absolute;left:50%;transform:translateX(-50%);
      fontSize:32px;
      margin:0;
    }

    .back-link
      margin-bottom 90px
      font-size 16px
      font-weight 500
      color #000
      text-decoration underline
      cursor pointer
      transition color 0.3s ease

    .back-link:hover
      color var(--blue)


</style>



// WEBPACK FOOTER //
// src/views/app/profile/index.vue